<svelte:options accessors/>
<script lang="ts">
    import NauiExpansionPanel from "../../../../naui/layout/NauiExpansionPanel.svelte";
    import NauiSwitch from "../../../../naui/atoms/NauiSwitch.svelte";
    import NauiCheckbox from "../../../../naui/atoms/NauiCheckbox.svelte";
    import DocumentTable from "../../../common/DocumentTable.svelte";
    import VehiculoCompletarDocumentos from "./VehiculoCompletarDocumentos.svelte";
    import NauiButton from "../../../../naui/atoms/NauiButton.svelte";

    export let data = {
        asegurado: {
            nombre: 'Ana María Galindo',
            identificacion: '1023456789',
            poliza: '654123456',
            fechaSiniestro: '12/02/2021',
            direccion: 'Calle 134 No 11 45 Apto 502',
            telefono: '6254312',
            telefonoOficina: '6254312',
            email: 'ana@gmail.com',
            celular: '3002753131',
            ocupacion: 'Ingeniera Industrial',
            marca: 'RENAULT',
            linea: 'DUSTER (FL) DYNAMIQUE/INTEN MT 1600CC 4x2',
            modelo: '2019',
            placa: 'FHY605',
            fechaRadicacion: '13/04/2021'
        },
        evento: {
            fechaOcurrencia: '18/03/2021 04:20 PM',
            direccionHechos: 'Avenida carrera 7 No 72 13 Frente a edificio HDI',
            pais: 'Colombia',
            departamento: 'Bogotá D.C.',
            municipio: 'Bogotá D.C.'
        },
        conductor: {
            permiso: false,
            aseguradoConducia: true,
            nombre: 'Ana María Galindo',
            identificacion: '1023456789',
            poliza: '654123456',
            fechaSiniestro: '12/02/2021',
            direccion: 'Calle 134 No 11 45 Apto 502',
            telefono: '6254312',
            email: 'ana@gmail.com',
            celular: '3002753131',
            ocupacion: 'Ingeniera Industrial',
            profesion: 'Ingeniera Industrial',
            edad: '34 años',
            afinidadAsegurado: 'Asegurado principal'
        },
        accidente: {
            descripcion: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor si',
            danosTerceros: true,
            descripcionDanosTerceros: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor si'
        },
        vehiculo: {
            descripcion: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor si',
            taller: 'Automar Bogotá',
            sucursal: 'Lorem ipsum',
            transito: true,
            detalleTransito: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor si',
            muertesLesionados: true
        },
        vehiculosTerceros: {
            list: [
                {
                    marca: 'RENAULT',
                    linea: 'DUSTER (FL) DYNAMIQUE/INTEN MT 1600CC 4x2',
                    placa: 'FHY605',
                    propietario: 'Lucía Buendía',
                    danos: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor si'
                },
                {
                    marca: 'RENAULT',
                    linea: 'DUSTER (FL) DYNAMIQUE/INTEN MT 1600CC 4x2',
                    placa: 'FHY605',
                    propietario: 'Lucía Buendía',
                    danos: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor si'
                }
            ],
            opinionResponsable: 'Tercero',
            opinionDetalle: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor si',
            declaracion: true
        }

    };


</script>
<section class="max-w-1000px">
    <!-- DATOS DEL ASEGURADO -->
    <NauiExpansionPanel>
        <div slot="header">
            <p class="primary">Datos del Asegurado</p>
        </div>
        <div class="py-1">
            <table class="simple-table">
                <tr>
                    <td style="min-width:200px">Nombre</td>
                    <td>{data.asegurado.nombre}</td>
                </tr>
                <tr>
                    <td>Identificación</td>
                    <td>{data.asegurado.identificacion}</td>
                </tr>
                <tr>
                    <td>No. Póliza</td>
                    <td>{data.asegurado.poliza}</td>
                </tr>
                <tr>
                    <td>Fecha Siniestro</td>
                    <td>{data.asegurado.fechaSiniestro}</td>
                </tr>
                <tr>
                    <td>Dirección</td>
                    <td>{data.asegurado.direccion}</td>
                </tr>
                <tr>
                    <td>Teléfono</td>
                    <td>{data.asegurado.telefono}</td>
                </tr>
                <tr>
                    <td>Teléfono Oficina</td>
                    <td>{data.asegurado.telefonoOficina}</td>
                </tr>
                <tr>
                    <td>E-mail</td>
                    <td>{data.asegurado.email}</td>
                </tr>
                <tr>
                    <td>Celular</td>
                    <td>{data.asegurado.celular}</td>
                </tr>
                <tr>
                    <td>Ocupación</td>
                    <td>{data.asegurado.ocupacion}</td>
                </tr>
                <tr>
                    <td>Marca</td>
                    <td>{data.asegurado.marca}</td>
                </tr>
                <tr>
                    <td>Línea - Clase</td>
                    <td>{data.asegurado.linea}</td>
                </tr>
                <tr>
                    <td>Modelo</td>
                    <td>{data.asegurado.modelo}</td>
                </tr>
                <tr>
                    <td>Placa</td>
                    <td>{data.asegurado.placa}</td>
                </tr>
                <tr>
                    <td>Fecha radicación</td>
                    <td>{data.asegurado.fechaRadicacion}</td>
                </tr>
            </table>
        </div>
    </NauiExpansionPanel>

    <!-- DATOS DEL EVENTO -->
    <NauiExpansionPanel>
        <div slot="header">
            <p class="primary">Datos del Evento</p>
        </div>
        <div class="py-1">
            <table class="simple-table">
                <tr>
                    <td style="min-width: 200px">Fecha de ocurrencia</td>
                    <td>{data.evento.fechaOcurrencia}</td>
                </tr>
                <tr>
                    <td>Dirección de los hechos</td>
                    <td>{data.evento.direccionHechos}</td>
                </tr>
                <tr>
                    <td>País</td>
                    <td>{data.evento.pais}</td>
                </tr>
                <tr>
                    <td>Departamento</td>
                    <td>{data.evento.departamento}</td>
                </tr>
                <tr>
                    <td>Municipio</td>
                    <td>{data.evento.municipio}</td>
                </tr>
            </table>
        </div>

    </NauiExpansionPanel>

    <!-- DATOS DEL CONDUCTOR -->
    <NauiExpansionPanel>
        <div slot="header">
            <p class="primary">Datos del Conductor</p>
        </div>
        <div class="py-1">
            <div class="box-l sx-ii mb-15">
                <p class="max-w-300px min-w-300px"><strong>¿El vehículo estaba siendo usado bajo orden o permiso del
                    asegurado?</strong></p>
                <NauiSwitch bind:active={data.conductor.permiso}/>
            </div>
            <div class="box-l sx-ii my-15">
                <p class="max-w-300px min-w-300px"><strong>¿El asegurado conducía el automóvil?</strong></p>
                <NauiSwitch bind:active={data.conductor.aseguradoConducia}/>
            </div>
            <table class="simple-table mt-15">
                <tr>
                    <td style="min-width:200px">Nombre</td>
                    <td>{data.conductor.nombre}</td>
                </tr>
                <tr>
                    <td>Identificación</td>
                    <td>{data.conductor.identificacion}</td>
                </tr>
                <tr>
                    <td>No. Póliza</td>
                    <td>{data.conductor.poliza}</td>
                </tr>
                <tr>
                    <td>Fecha Siniestro</td>
                    <td>{data.conductor.fechaSiniestro}</td>
                </tr>
                <tr>
                    <td>Dirección</td>
                    <td>{data.conductor.direccion}</td>
                </tr>
                <tr>
                    <td>Teléfono</td>
                    <td>{data.conductor.telefono}</td>
                </tr>
                <tr>
                    <td>E-mail</td>
                    <td>{data.conductor.email}</td>
                </tr>
                <tr>
                    <td>Celular</td>
                    <td>{data.conductor.celular}</td>
                </tr>
                <tr>
                    <td>Ocupación</td>
                    <td>{data.conductor.ocupacion}</td>
                </tr>
                <tr>
                    <td>Profesión</td>
                    <td>{data.conductor.profesion}</td>
                </tr>
                <tr>
                    <td>Edad</td>
                    <td>{data.conductor.edad}</td>
                </tr>
                <tr>
                    <td>Afinidad asegurado</td>
                    <td>{data.conductor.afinidadAsegurado}</td>
                </tr>
            </table>
        </div>
    </NauiExpansionPanel>


    <!-- DETALLES ACCIDENTE -->
    <NauiExpansionPanel>
        <div slot="header">
            <p class="primary">Detalle Accidente</p>
        </div>
        <div class="py-1">
            <textarea class="naui-input w-100 input-back" bind:value={data.accidente.descripcion} disabled></textarea>
            <div class="box-l sx-ii my-15">
                <p class="max-w-300px min-w-300px"><strong>¿Se causaron daños a tercero con el vehículo
                    asegurado?</strong></p>
                <NauiSwitch bind:active={data.accidente.danosTerceros}/>
            </div>

            <textarea class="naui-input w-100 input-back" bind:value={data.accidente.descripcionDanosTerceros}
                      disabled></textarea>

        </div>
    </NauiExpansionPanel>

    <!-- DAÑOS VEHÍCULO -->
    <NauiExpansionPanel>
        <div slot="header">
            <p class="primary">Daños a Vehículo Asegurado</p>
        </div>
        <div class="py-1">
            <label class="inline-block mb-ii">Descripción de los daños</label>
            <textarea class="naui-input w-100 input-back" bind:value={data.vehiculo.descripcion} disabled></textarea>
            <table class="simple-table mt-1">
                <tr>
                    <td style="min-width: 200px">Taller asignado</td>
                    <td>{data.vehiculo.taller}</td>
                </tr>
                <tr>
                    <td>Sucursal</td>
                    <td>{data.vehiculo.sucursal}</td>
                </tr>
            </table>
            <div class="box-l sx-ii my-15">
                <p class="max-w-300px min-w-300px"><strong>¿Intervino autoridad de tránsito?</strong></p>
                <NauiSwitch bind:active={data.vehiculo.transito}/>
            </div>
            <textarea class="naui-input w-100 input-back" bind:value={data.vehiculo.detalleTransito} disabled></textarea>
            <div class="box-l sx-ii mt-15">
                <p class="max-w-300px min-w-300px"><strong>¿Hubo muertes y/o lesionados?</strong></p>
                <NauiSwitch bind:active={data.vehiculo.muertesLesionados}/>
            </div>

        </div>
    </NauiExpansionPanel>

    <!-- VEHÍCULOS DE TERCEROS -->
    <NauiExpansionPanel>
        <div slot="header">
            <p class="primary">Vehículos de Terceros Involucrados</p>
        </div>
        <div class="py-1">
            {#each data.vehiculosTerceros.list as vehiculo, index}
                <div>
                    <p class="mb-1"><strong>Vehiculo {index + 1}</strong></p>
                    <table class="simple-table mb-15">
                        <tr>
                            <td style="min-width: 200px">Marca</td>
                            <td>{vehiculo.marca}</td>
                        </tr>
                        <tr>
                            <td>Línea - Clase</td>
                            <td>{vehiculo.linea}</td>
                        </tr>
                        <tr>
                            <td>Placa</td>
                            <td>{vehiculo.placa}</td>
                        </tr>
                        <tr>
                            <td>Propietario</td>
                            <td>{vehiculo.propietario}</td>
                        </tr>
                    </table>
                    <label class="inline-block mb-ii">Descripción de los daños</label>
                    <textarea class="naui-input w-100 mb-15 input-back" bind:value={vehiculo.danos} disabled></textarea>
                </div>
            {/each}

            <label class="mb-ii inline-block">En su opinión, quién fue responsable del
                accidente: {data.vehiculosTerceros.opinionResponsable}</label>
            <textarea class="naui-input w-100 mb-15 input-back" bind:value={data.vehiculosTerceros.opinionDetalle}
                      disabled></textarea>
            <NauiCheckbox bind:value={data.vehiculosTerceros.declaracion}
                          label="Declaro que los datos e información suministrados en la presente declaración son verídicos y que no se ha omitido ningún hecho o detalle importante relacionado con las preguntas anteriores. Nos comprometemos a colaborar con HDI Seguros S. A. En la mejor defensa de sus intereses. "/>
        </div>
    </NauiExpansionPanel>

    <NauiExpansionPanel>
        <div slot="header">
            <p class="primary">Adjuntar Documentos</p>
        </div>
        <div>
            <VehiculoCompletarDocumentos />
        </div>
    </NauiExpansionPanel>

    <div class="box-l sx-1 mt-2">
        <NauiButton caption="Volver" mode="outline" color="accent" className="min-w-200px" />
        <NauiButton caption="Finalizar y enviar" mode="solid" color="accent" className="min-w-200px" />
    </div>

</section>